import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';

import { useFileStore } from '..';

export const useFileAccess = (fileId?: string) => {
  const router = useRouter();
  const effectiveFileId = fileId || (router.query.slug as string);
  const currentFile = useFileStore(useCallback((s) => s.files[effectiveFileId], [effectiveFileId]));
  const { isPublicFile } = useAuth((s) => ({
    isPublicFile: s.isPublicFile,
  }));

  const isReadOnly = React.useMemo(
    () => currentFile?.access === 'view' || (isPublicFile as boolean),
    [currentFile?.access, isPublicFile]
  );
  const isFullAccess = React.useMemo(
    () => !isPublicFile && (!currentFile?.access || currentFile?.access === 'full'),
    [currentFile?.access, isPublicFile]
  );

  return {
    isReadOnly,
    isFullAccess,
  };
};
